import { render, staticRenderFns } from "./SizeSelection.vue?vue&type=template&id=38558c0d"
import script from "./SizeSelection.vue?vue&type=script&lang=js"
export * from "./SizeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports